export default __webpack_public_path__ + "static/media/1724.b9dfc560.png";